import React from 'react';

import { COMPANY_HUB_SETTINGS_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { CompanyHubSettingsPage } from '@confluence/company-hub/entry-points/CompanyHubSettingsPage.ts';
import { COMPANY_HUB_SETTINGS } from '@confluence/named-routes/entry-points/routes.ts';
import { getCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { getCompanyHubPseudoAppRoute } from '@confluence/ssr-app/entry-points/getCompanyHubPseudoAppRoute.ts';
import type { RouteWithNavParamsType } from '@confluence/ssr-app/entry-points/routes.ts';

/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */
const ConfluenceAppHubSettingsRoute = () => <CompanyHubSettingsPage />;

ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = () => {
	const navView = COMPANY_HUB_SETTINGS_ID;

	return {
		Screen: {
			screenEvent: {
				name: 'companyHubSettingsScreen',
				attributes: {
					// Company Hub hides its space from the user, doesn't refer to its page
					// as such, is rather presented to the user as "a new surface", and thus
					// doesn't constitute space usage from the perspective of the user.
					screenIsInSpace: false,
				},
			},
			pageState: {
				routeName: COMPANY_HUB_SETTINGS.name,
				spaceKey: getCompanyHubSpaceKey(),
			},
		},
		MainLayout: {
			navView,
		},
	};
};

/**
 * The route "Company Hub settings" in the Company Hub pseudo app if enabled; otherwise, in the Confluence app.
 */
export const CompanyHubSettingsRoute: RouteWithNavParamsType = getCompanyHubPseudoAppRoute(
	ConfluenceAppHubSettingsRoute,
);
